import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
  const gridResults = document.querySelector(
    '#results-slider .grid-results .swiper-wrapper'
  );
  const gridResultsAmount = gridResults.dataset.totalResults;
  // results slider
  const resultsSwiper = new Swiper('#results-slider .grid-results', {
    modules: [Navigation, Pagination, A11y],
    // navigation: {
    //   nextEl: '#results-slider .swiper-button-next',
    //   prevEl: '#results-slider .swiper-button-prev',
    // },
    pagination: {
      el: '#results-slider .swiper-pagination',
      clickable: true,
    },
    a11y: true,
    autoHeight: true,
    keyboardControl: true,
    grabCursor: true,
    watchOverflow: true,
    loop: true,
    observer: true,
    updateOnWindowResize: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        
        observer: true,
        updateOnWindowResize: true,
      },
      768: {
        slidesPerView: 3,
        pagination: false,
        allowSlideNext: false,
        allowSlidePrev: false,
        grabCursor: false,
        
        observer: true,
        updateOnWindowResize: true,
      },
      1200: {
        slidesPerView: 3,
        pagination: false,
        allowSlideNext: false,
        allowSlidePrev: false,
        grabCursor: false,
      },
      1400: {
        slidesPerView: 3,
        // slidesPerGroup: 5,
        pagination: false,
        allowSlideNext: false,
        allowSlidePrev: false,
        grabCursor: false,
        // spaceBetween: 45,
        // loop: gridResultsAmount > 5,
      },
    },
  });
  

  // if( window.matchMedia('(max-width: 1024px) and (min-width: 768px)').matches ) {
  //       screen.orientation.addEventListener('change', function(e) {
  //         window.location.reload(); 
  //       });
  // }

  //  listen for browser size changes
  window.onresize = function () {
    resultsSwiper.update();
  };
};
